import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { ComingSoonText, Logo } from 'assets/landing';
import { InvitationModal } from 'components/invitationModal';
import Styles from './comingSoon.module.scss';

const ComingSoon = () => {
	const [showInvite, setShowInvite] = useState(false);
	const [searchParams] = useSearchParams();

	const campaignInviteID = searchParams.get('campaignInviteID');

	useEffect(() => {
		if (campaignInviteID) {
			setShowInvite(true);
		}
	}, [campaignInviteID]);

	return (
		<div className={Styles.container}>
			<img className={Styles.logo} src={Logo} alt="" />
			<ComingSoonText />
			<InvitationModal show={showInvite} onClose={() => setShowInvite(false)} />
		</div>
	);
};

export default ComingSoon;
